import axiosConfig from "../../../config/axiosConfig";
import {
  INITIATE_PRICING_URL,
  INVENTORY_CHECK_URL,
  PRICING_STATE_CHECK_URL,
  UPDATE_LRU_SALES_URL,
  UPDATE_RP_INVENTORY_CHECK_URL,
} from "../../../config/config";
import { createQueryParams, getStringFromArray } from "../../../utils/helper";

export const GetInventoryCheckService = (params) => {
  try {
    const {
      page,
      per_page,
      ordering,
      slug,
      type,
      summary,
      comp_type,
      part_number,
      serial_number,
      description,
      quantity,
      ata_chapter_source,
      actual_pn,
      clp,
      mod,
      ipc_ref,
      typical_pn,
      tier,
      benign_scrap_rate,
      expected_yield,
      sales_total,
      ata_chapter,
      stock_status,
      part_class_description,
    } = params || {};

    const paramsList = {
      page,
      per_page,
      ordering,
      summary,
      part_number,
      serial_number,
      description,
      quantity,
      ata_chapter_source,
      actual_pn,
      clp,
      mod,
      ipc_ref,
      typical_pn,
      tier: getStringFromArray(tier),
      benign_scrap_rate,
      expected_yield,
      sales_total: sales_total ? Number(sales_total) : "",
      ata_chapter,
      stock_status: stock_status?.value,
      part_class_description: getStringFromArray(part_class_description),
    };
    const queryString = createQueryParams(paramsList);

    const url = comp_type
      ? `${INVENTORY_CHECK_URL}/${type}/${slug}/${comp_type}${queryString ? `?${queryString}` : ""}`
      : `${INVENTORY_CHECK_URL}/${type}/${slug}${queryString ? `?${queryString}` : ""}`;

    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const GetAircraftInventoryCheckSummaryService = (params) => {
  try {
    const { slug, type, forcast_month } = params || {};

    const url = `${INVENTORY_CHECK_URL}/${type}/${slug}/summary?forcast_month=${forcast_month}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const UpdateRepairPercentageService = ({ data, params }) => {
  const { slug, type, comp_type } = params || {};
  const url = comp_type
    ? `${INVENTORY_CHECK_URL}/${type}/${slug}/${comp_type}`
    : `${INVENTORY_CHECK_URL}/${type}/${slug}`;
  return axiosConfig.patch(url, data);
};

export const UpdateAssuemedConfigService = ({ data, params }) => {
  const { slug, action } = params || {};
  const paramsList = {
    action,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${UPDATE_LRU_SALES_URL}/update/${slug}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.patch(url, data);
};

export const UpdateRPService = (params) => {
  try {
    const { slug, rp, slug_list } = params || {};

    const url = `${UPDATE_RP_INVENTORY_CHECK_URL}/${slug}`;

    return axiosConfig.patch(url, { repair_percent: rp, slug_list });
  } catch (error) {
    throw error;
  }
};

export const InitiatePricingService = (params) => {
  try {
    const { slug, regenerate } = params || {};

    const paramsList = {
      regenerate,
    };
    const queryString = createQueryParams(paramsList);

    const url = `${INITIATE_PRICING_URL}/${slug}${queryString ? `?${queryString}` : ""}`;

    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const CheckPricingStateService = (params) => {
  try {
    const { slug } = params || {};

    const url = `${PRICING_STATE_CHECK_URL}/${slug}`;

    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};
